import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs';
import { UrlBuilderService } from '@common/services/url-builder.service';
import { Creditor, CreditorAccount } from '@feature/creditor-accounts/models/creditor-account-model';

@Injectable({
  providedIn: 'root'
})
export class CreditorAccountsHttpService {

  constructor(
    private readonly http: HttpClient,
    private readonly urlBuilderService: UrlBuilderService) { }

  getCreditorAccounts(): Observable<CreditorAccount[]> {
    const url = this.urlBuilderService.getUrl(`creditor/accounts`);
    return this.http
      .get<CreditorAccount[]>(url).pipe(
        map(accounts => accounts || undefined)
      );
  }


  getCreditorAccountsBySupplierRef(supplierRef: number): Observable<CreditorAccount[]> {
    const url = this.urlBuilderService.getUrl(`supplier/${supplierRef}/creditor/accounts`);
    return this.http
      .get<CreditorAccount[]>(url).pipe(
        map(accounts => accounts || undefined)
      );
  }

  getUserCreditors(): Observable<Creditor[]> {
    const url = this.urlBuilderService.getUrl(`usercreditors`);
    return this.http.get<Creditor[]>(url);
  }

}
